// These map directly to the internal Monaco types
// https://microsoft.github.io/monaco-editor/api/enums/monaco.languages.completionitemkind.html
export let AutoCompletionKind = /*#__PURE__*/function (AutoCompletionKind) {
  AutoCompletionKind[AutoCompletionKind["Method"] = 0] = "Method";
  AutoCompletionKind[AutoCompletionKind["Function"] = 1] = "Function";
  AutoCompletionKind[AutoCompletionKind["Constructor"] = 2] = "Constructor";
  AutoCompletionKind[AutoCompletionKind["Field"] = 3] = "Field";
  AutoCompletionKind[AutoCompletionKind["Variable"] = 4] = "Variable";
  AutoCompletionKind[AutoCompletionKind["Class"] = 5] = "Class";
  AutoCompletionKind[AutoCompletionKind["Struct"] = 6] = "Struct";
  AutoCompletionKind[AutoCompletionKind["Interface"] = 7] = "Interface";
  AutoCompletionKind[AutoCompletionKind["Module"] = 8] = "Module";
  AutoCompletionKind[AutoCompletionKind["Property"] = 9] = "Property";
  AutoCompletionKind[AutoCompletionKind["Event"] = 10] = "Event";
  AutoCompletionKind[AutoCompletionKind["Operator"] = 11] = "Operator";
  AutoCompletionKind[AutoCompletionKind["Unit"] = 12] = "Unit";
  AutoCompletionKind[AutoCompletionKind["Value"] = 13] = "Value";
  AutoCompletionKind[AutoCompletionKind["Constant"] = 14] = "Constant";
  AutoCompletionKind[AutoCompletionKind["Enum"] = 15] = "Enum";
  AutoCompletionKind[AutoCompletionKind["EnumMember"] = 16] = "EnumMember";
  AutoCompletionKind[AutoCompletionKind["Keyword"] = 17] = "Keyword";
  AutoCompletionKind[AutoCompletionKind["Text"] = 18] = "Text";
  AutoCompletionKind[AutoCompletionKind["Color"] = 19] = "Color";
  AutoCompletionKind[AutoCompletionKind["File"] = 20] = "File";
  AutoCompletionKind[AutoCompletionKind["Reference"] = 21] = "Reference";
  AutoCompletionKind[AutoCompletionKind["Customcolor"] = 22] = "Customcolor";
  AutoCompletionKind[AutoCompletionKind["Folder"] = 23] = "Folder";
  AutoCompletionKind[AutoCompletionKind["TypeParameter"] = 24] = "TypeParameter";
  AutoCompletionKind[AutoCompletionKind["Snippet"] = 25] = "Snippet";
  return AutoCompletionKind;
}({});